<template>
    <div
        id="lt-yantr"
        class="rate-table-personal-v2 yantr-tracking">
        <div class="container-width">
            <div class="title-block">
                <h2>Personal Loans: $1,000 to $50,000</h2>
                <div class="zip-code-block hidden-xs">
                    <span v-show="ShowLocation">
                        <i class="lt4-MapPin"></i>
                        {{ GeoLocationData.city + ', ' + GeoLocationData.state }}
                    </span>
                </div>
            </div>
            <div class="found-lender">
                We found <b>{{ TotalOffers }} personal loans</b> for <b>${{ currencyFilter(LoanAmount) }}</b>
            </div>
            <div class="adv-disclosure-block">
                <template v-if="ShowHdltgp">
                    <button
                        id="ltPaidBtn"
                        class="lt-paid a11y-modal-trigger"
                        data-target="ltPaid">
                        {{ ltPaidTitle }}
                    </button>
                    <div class="dsk-lt-paid">
                        <tooltip-view
                            :label="ltPaidTitle"
                            :show-on-over="ShowOnOver"
                            :popper-content="ltPaidDescription"
                            reference-element="open me"
                        />
                    </div>
                </template>
                <advertising-disclosures
                    v-if="DisclosureText"
                    :disclosure-text="disclosureText"
                    :disclosure-tokens="disclosureTokens"
                    :open-disclosure-modal="openDisclosureModal"
                />
            </div>
            <button
                id="modalTrigeer"
                class="btn btn-blue btn-outline visible-xs a11y-modal-trigger"
                data-target="filterModal">
                <i class="lt-icons lt4-Funnel"></i> Filter Results (4)
            </button>
            <section class="filter-section">
                <form class="input-form">
                    <div class="filter-block">
                        <div
                            class="percentage-input"
                            :class="LoanAmountNav ? 'active' : ''">
                            <number-input
                                id="loanAmount"
                                v-model="LoanAmount"
                                :label="labelLoanAmount"
                                inputmode="decimal"
                                symbol="$"
                                maxlength="5"
                                @inputBlur="checkLoanAmount"
                            />
                        </div>
                        <div :class="CreditScoreNav ? 'active' : ''">
                            <drop-down
                                id="creditScore"
                                v-model="CreditScore"
                                :label="labelCreditScore"
                                :options="CreditScoreList"
                                @input="GetSelectedCreditScore"
                            />
                        </div>
                        <div :class="LoanPurposeNav ? 'active' : ''">
                            <drop-down
                                id="LoanPurpose"
                                v-model="PersonalLoanPurpose"
                                :label="labelLoanPurpose"
                                :options="PersonalLoanPurposeList"
                            />
                        </div>
                        <div :class="ZipCodeNav ? 'active' : ''">
                            <div class="form-group">
                                <geo-by-zip-input
                                    ref="geoByZip"
                                    v-model="GeoLocation"
                                    :label="labelZipCode"
                                    :zip-code="GeoLocationData.zipCode"
                                    @showHideLocation="showHideLocation()"
                                    @input="getGeoDetails"
                                />
                            </div>
                        </div>
                        <div class="rate-table-filter-btn-div">
                            <button
                                type="button"
                                class="btn btn-blue btn-outline apply-filter-btn"
                                :disabled="ShowZipCodeError"
                                @click="fetchLenders()">
                                Apply Filters
                            </button>
                        </div>
                    </div>
                </form>
            </section>
            <section class="a11y-tab-container">
                <ul
                    class="tab-nav"
                    role="tablist">
                    <li
                        class="sort-by"
                        role="presentation"
                        tabindex="-1">
                        Sort <span class="visually-hidden">results </span> By:
                    </li>
                    <li
                        id="li-low-apr"
                        :class="{'active': ShowLowestAPR}"
                        role="presentation"
                        :tabindex="ShowLowestAPR ? '0' : '-1'"
                        @click="ShowLowestAPR = true"
                        @keydown="tabClick($event, Offers, 'minApr', true)">
                        <button
                            id="low-apr"
                            role="tab"
                            data-target="#tab1"
                            aria-controls="tab1"
                            :aria-expanded="ShowLowestAPR"
                            tabindex="1">
                            <span class="hidden-xs">Lowest </span>APR
                        </button>
                    </li>
                    <li
                        id="li-low-loan-payment"
                        :class="{'active': !ShowLowestAPR}"
                        :tabindex="!ShowLowestAPR ? '0' : '-1'"
                        role="presentation"
                        @click="ShowLowestAPR = false"
                        @keydown="tabClick($event, Offers, 'estPayment', false)">
                        <button
                            id="low-loan-payment"
                            role="tab"
                            data-target="#tab2"
                            aria-controls="tab2"
                            :aria-expanded="!ShowLowestAPR"
                            tabindex="1">
                            <span class="hidden-xs">Lowest </span>Loan Payment
                        </button>
                    </li>
                </ul>
                <div class="tab-content">
                    <div
                        v-show="ShowLowestAPR"
                        id="tab1"
                        class="offer-block"
                        :class="{'active': ShowLowestAPR}"
                        aria-labelledby="low-apr"
                        role="tabpanel">
                        <table class="offer-result">
                            <thead class="visually-hidden">
                                <tr>
                                    <th>Lender Logo</th>
                                    <th>{{ checkAPR(ShowLowestAPR) }}</th>
                                    <th>{{ checkESP(ShowLowestAPR) }}</th>
                                    <th>Loan Term</th>
                                    <th>Minimum Credit Score Needed</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <personal-loan-offers
                                    v-for="(offer) in MinAprOffers"
                                    :key="offer.lenderId"
                                    :offer="offer"
                                    :tooltip-monthly-payment="tooltipMonthlyPayment"
                                    :destination-button-css-class="destinationButtonCssClass"
                                    :destination-button-text="destinationButtonText"
                                    :destination-target="DestinationTarget"
                                    :destination-link-or-id="DestinationLinkOrId"
                                    :loan-amount="LoanAmount"
                                    :show-lowest-apr="ShowLowestAPR"
                                    :cta-params="ctaParams"
                                    :field-edited="fieldEdited"
                                />
                            </tbody>
                        </table>
                    </div>
                    <div
                        v-show="!ShowLowestAPR"
                        id="tab2"
                        class="offer-block"
                        :class="{'active': !ShowLowestAPR}"
                        aria-labelledby="low-loan-payment"
                        role="tabpanel">
                        <table class="offer-result">
                            <thead class="visually-hidden">
                                <tr>
                                    <th>Lender Logo</th>
                                    <th>{{ checkAPR(ShowLowestAPR) }}</th>
                                    <th>{{ checkESP(ShowLowestAPR) }}</th>
                                    <th>Loan Term</th>
                                    <th>Minimum Credit Score Needed</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <personal-loan-offers
                                    v-for="(offer) in EstPaymentOffers"
                                    :key="offer.lenderId"
                                    :offer="offer"
                                    :tooltip-monthly-payment="tooltipMonthlyPayment"
                                    :destination-button-css-class="destinationButtonCssClass"
                                    :destination-button-text="destinationButtonText"
                                    :destination-target="DestinationTarget"
                                    :destination-link-or-id="DestinationLinkOrId"
                                    :loan-amount="LoanAmount"
                                    :show-lowest-apr="ShowLowestAPR"
                                    :cta-params="ctaParams"
                                    :field-edited="fieldEdited"
                                />
                            </tbody>
                        </table>
                    </div>
                    <div class="offers-desc">
                        *The Rates, APRs, Fees, and Monthly Amounts above are estimates only and are not guaranteed. The information provided is for illustrative purposes only and is merely a conditional quote subject to change, may not be available in all states and are based on loan amount requested and creditworthiness as determined by the lender selected. When you proceed with a lender, they will inquire into your credit and such inquiry will impact your credit score. Your financial information will be required to be verified and subject to formal credit approval by the lender selected. LendingTree receives payment from the lenders on a cost per click and/or closed loan fee, but provides its services free of charge to you to search and compare lenders.
                        The Personal Loan offers that appear on this site are from companies from which LendingTree receives compensation. This compensation may impact how and where products appear on this site (including for example, the order in which they appear or whether a lender is "featured" on the site). LendingTree does not include all Personal Loan companies or all types of offers available in the marketplace.<br /><br />
                        Personal Loan Providers determine the underwriting criteria necessary for approval; you should review each Provider's terms and conditions to determine which loan works for you and your personal financial situation. All reasonable efforts are made to provide and maintain accurate information. All rates, fees, and terms are presented without guarantee and are subject to change pursuant to each Provider's discretion. There is no guarantee you will be approved for credit or that upon approval you will qualify for the advertised rates, fees, or terms shown.<br /><br />
                        <a :href="DisclosureLink">Learn more about how our personal loan rate table works</a>
                    </div>
                </div>
            </section>
        </div>
        <a11y-modal
            v-if="ShowHdltgp"
            id="ltPaid">
            <template #h4>
                {{ ltPaidTitle }}
            </template>
            <div slot="body">
                <div class="description">
                    <p> {{ ltPaidDescription }} </p>
                </div>
            </div>
        </a11y-modal>
        <a11y-modal :id="modalId">
            <div slot="body">
                <section class="filter-section">
                    <form class="input-form">
                        <h2
                            id="filterModal_heading"
                            class="filter-mob-header visible-xs">
                            Filter results by:
                        </h2>
                        <div class="filter-block">
                            <div
                                class="percentage-input"
                                :class="LoanAmountNav ? 'active' : ''">
                                <button
                                    id="loan_amount_aria"
                                    type="button"
                                    aria-controls="loan_amount_section"
                                    :aria-expanded="LoanAmountNav ? 'true' : 'false'"
                                    :class="LoanAmountNav ? 'lt4-Minus' : 'lt4-Plus'"
                                    @click="LoanAmountNav = !LoanAmountNav"></button>
                                <div
                                    class="filter-result"
                                    @click="LoanAmountNav = !LoanAmountNav">
                                    <span>{{ labelLoanAmount }}</span>
                                    <b>{{ LoanAmount }}</b>
                                </div>
                                <div
                                    id="loan_amount_section"
                                    aria-labelledby="loan_amount_aria"
                                    :aria-hidden="LoanAmountNav ? 'false' : 'true'">
                                    <number-input
                                        id="loanAmount"
                                        v-model="LoanAmount"
                                        :label="labelLoanAmount"
                                        inputmode="decimal"
                                        symbol="$"
                                        maxlength="5"
                                        @inputBlur="checkLoanAmount"
                                    />
                                </div>
                            </div>
                            <div :class="CreditScoreNav ? 'active' : ''">
                                <button
                                    id="credit_score_aria"
                                    type="button"
                                    aria-controls="credit_score_section"
                                    :aria-expanded="CreditScoreNav ? 'true' : 'false'"
                                    :class="CreditScoreNav ? 'lt4-Minus' : 'lt4-Plus'"
                                    @click="CreditScoreNav = !CreditScoreNav"></button>
                                <div
                                    class="filter-result"
                                    @click="CreditScoreNav = !CreditScoreNav">
                                    <span for="creditScore">{{ labelCreditScore }}</span>
                                    <b>{{ SelectedCreditScore }}</b>
                                </div>
                                <div
                                    id="credit_score_section"
                                    aria-labelledby="credit_score_aria"
                                    :aria-hidden="CreditScoreNav ? 'false' : 'true'">
                                    <drop-down
                                        id="creditScore"
                                        v-model="CreditScore"
                                        :label="labelCreditScore"
                                        :options="CreditScoreList"
                                        @input="GetSelectedCreditScore"
                                    />
                                </div>
                            </div>
                            <div :class="LoanPurposeNav ? 'active' : ''">
                                <button
                                    id="loan_purpose_aria"
                                    type="button"
                                    aria-controls="loan_purpose_section"
                                    :aria-expanded="LoanPurposeNav ? 'true' : 'false'"
                                    :class="LoanPurposeNav ? 'lt4-Minus' : 'lt4-Plus'"
                                    @click="LoanPurposeNav = !LoanPurposeNav"></button>
                                <div
                                    class="filter-result"
                                    @click="LoanPurposeNav = !LoanPurposeNav">
                                    <span for="LoanPurpose">{{ labelLoanPurpose }}</span>
                                    <b>{{ PersonalLoanPurpose }}</b>
                                </div>
                                <div
                                    id="loan_purpose_section"
                                    aria-labelledby="loan_purpose_aria"
                                    :aria-hidden="LoanPurposeNav ? 'false' : 'true'">
                                    <drop-down
                                        id="LoanPurpose"
                                        v-model="PersonalLoanPurpose"
                                        :label="labelLoanPurpose"
                                        :options="PersonalLoanPurposeList"
                                    />
                                </div>
                            </div>
                            <div
                                class="visible-xs"
                                :class="ZipCodeNav ? 'active' : ''">
                                <button
                                    id="zip_code_aria"
                                    type="button"
                                    aria-controls="zip_code_section"
                                    :aria-expanded="ZipCodeNav ? 'true' : 'false'"
                                    :class="ZipCodeNav ? 'lt4-Minus' : 'lt4-Plus'"
                                    @click="ZipCodeNav = !ZipCodeNav"></button>
                                <div
                                    class="filter-result"
                                    @click="ZipCodeNav = !ZipCodeNav">
                                    <span for="zipCode">{{ labelZipCode }}</span>
                                    <b>{{ GeoLocationData.zipCode }}</b>
                                </div>
                                <div
                                    id="zip_code_section"
                                    class="form-group"
                                    aria-labelledby="zip_code_aria"
                                    :aria-hidden="ZipCodeNav ? 'false' : 'true'">
                                    <geo-by-zip-input
                                        ref="geoByZip"
                                        v-model="GeoLocation"
                                        :label="labelZipCode"
                                        :zip-code="GeoLocationData.zipCode"
                                        @showHideLocation="showHideLocation()"
                                        @input="getGeoDetails"
                                    />
                                </div>
                            </div>
                            <div>
                                <button
                                    type="button"
                                    class="btn btn-blue btn-outline apply-filter-btn"
                                    :disabled="ShowZipCodeError"
                                    @click="fetchLenders(), closeA11yModal()">
                                    Apply Filters
                                </button>
                            </div>
                        </div>
                    </form>
                </section>
            </div>
        </a11y-modal>
    </div>
</template>
<script>
    import Accounting from 'accounting';
    import { find } from 'lodash-es';
    import BaseMixin from '~/mixin/base-mixin';
    import GeoByZipInput from '~/components/geo-by-zip-input.vue';
    import NumberInput from '~/components/number-input.vue';
    import DropDown from '~/components/drop-down.vue';
    import CreditScoreList from '~/constants/credit-score-list';
    import LoanTypeList from '~/constants/loan-type-list';
    import AdvertisingDisclosures from '~/components/advertising-disclosures.vue';
    import GetLocation from '~/mixin/get-geo-location';
    import GraphQLMixin from '~/mixin/graphql';
    import getPLOffers from './getPLOffers.gql';
    import { getFinancialApiUrl, setHeader } from '~/helpers/financialapi-url-env';
    import PersonalLoanOffers from './personal-loan-offers.vue';
    import LenderService from '~/services/lender-detail-service';
    import PaymentHelper from '~/helpers/payment';
    import wwwUrlEnv from '~/helpers/www-url-env';
    import wwwSplitterUrlEnv from '~/helpers/splitter-url-env';
    import a11yModal from '~/helpers/a11y-modal';
    import A11yModal from '~/components/a11y-modal.vue';
    import TooltipView from '~/components/tooltip-view.vue';
    import RateTableInfo from '~/mixin/rate-table-offer-tracking';

    export default {
        components: {
            GeoByZipInput,
            NumberInput,
            DropDown,
            AdvertisingDisclosures,
            PersonalLoanOffers,
            A11yModal,
            TooltipView,
        },
        mixins: [BaseMixin, GraphQLMixin, RateTableInfo],
        props: {
            labelZipCode: {
                default: 'Zip Code',
            },
            zipCode: {
                default: '28277',
            },
            showLocation: {
                default: true,
            },
            labelLoanAmount: {
                default: 'Loan Amount',
            },
            loanAmount: {
                default: 10000,
            },
            labelCreditScore: {
                default: 'Credit Score:',
            },
            creditScore: {
                default: 3,
            },
            labelLoanPurpose: {
                default: 'Loan Purpose:',
            },
            personalLoanPurpose: {
                default: 'Debt Consolidation',
            },
            tooltipMonthlyPayment: {
                default: 'monthly-payment',
            },
            disclosureText: {
                default: 'Disclosures',
            },
            disclosureTokens: {
                default: '93',
            },
            loanAmountNav: {
                default: false,
            },
            creditScoreNav: {
                default: false,
            },
            loanPurposeNav: {
                default: false,
            },
            zipCodeNav: {
                default: false,
            },
            destinationLinkOrId: {
                default: 'catch-all-pl',
            },
            destinationButtonCssClass: {
                default: 'btn btn-orange',
            },
            destinationButtonText: {
                default: 'Get Free Offers',
            },
            disclosureLink: {
                default: `${wwwUrlEnv.getWWWURL()}/legal/advertising-disclosures/?disclosures=126`,
            },
            destinationTarget: {
                default: `${wwwSplitterUrlEnv.getSplitterURL()}/api/split?id=catch-all-pl`,
            },
            graphQlUri: {
                default: '',
            },
            ltPaidTitle: {
                default: 'How Does LendingTree Get Paid?',
            },
            ltPaidDescription: {
                default: 'LendingTree is compensated by companies on this site, and this compensation may impact how and where offers appears on this site (such as the order).  LendingTree does not include all lenders, savings products or loan options available in the marketplace.',
            },
            showQuestionMark: {
                default: true,
            },
            ctaParams: {
                default: '',
            },
            ariaExpanded: {
                default: 'true',
            },
            expanded: {
                default: 'false',
            },
            modalId: {
                type: String,
                default: 'filterModal',
            },
            showOnOver: {
                default: true,
            },
            openDisclosureModal: {
                default: true,
            },
            hideHdltgp: {
                default: false,
            },
        },
        data() {
            return {
                GeoLocation: {
                    zipCode: this.zipCode,
                },
                ShowLocation: this.showLocation,
                LoanAmount: this.loanAmount,
                CreditScore: this.creditScore,
                CreditScoreList: [],
                PersonalLoanPurposeList: [],
                PersonalLoanPurpose: this.personalLoanPurpose,
                DisclosureText: this.disclosureText,
                DisclosureTokens: this.disclosureTokens,
                LoanAmountNav: this.loanAmountNav,
                CreditScoreNav: this.creditScoreNav,
                LoanPurposeNav: this.loanPurposeNav,
                ZipCodeNav: this.zipCodeNav,
                DestinationLinkOrId: this.destinationLinkOrId,
                DestinationButtonText: this.destinationButtonText,
                DestinationTarget: this.destinationTarget,
                SelectedCreditScore: '',
                ShowZipCodeError: false,
                ZipCode: this.zipCode,
                ShowZipCode: false,
                GraphQlUri: this.graphQlUri,
                Offers: [],
                MinAprOffers: [],
                EstPaymentOffers: [],
                TotalOffers: 0,
                LenderIds: [],
                isPLfatched: false,
                ShowLowestAPR: true,
                DisclosureLink: this.disclosureLink,
                ShowQuestionMark: this.showQuestionMark,
                showModal: false,
                tab: 'tab1',
                ariaLabel: 'low-apr',
                AriaExpanded: this.ariaExpanded,
                Expanded: this.expanded,
                ShowOnOver: this.showOnOver,
                ShowHdltgp: !this.hideHdltgp,
            };
        },
        computed: {
            GeoLocationData() {
                return this.GeoLocation;
            },
        },
        watch: {
            isPLfatched() {
                LenderService.getLenderDetailsList(this.LenderIds, this.updateLenderDetails);
                this.$nextTick(() => {
                    this.LoanAmount = this.currencyFilter(this.LoanAmount);
                });
            },
            LoanAmount(newValue, oldValue) {
                if (Accounting.unformat(newValue) !== Accounting.unformat(oldValue)) {
                    this.fieldEdited = 'yes';
                }
            },
            CreditScore(newValue, oldValue) {
                if (newValue !== oldValue) {
                    this.fieldEdited = 'yes';
                }
            },
            PersonalLoanPurpose(newValue, oldValue) {
                if (newValue !== oldValue) {
                    this.fieldEdited = 'yes';
                }
            },
            ZipCode(newValue, oldValue) {
                if (newValue !== oldValue) {
                    this.fieldEdited = 'yes';
                }
            },
            ShowLowestAPR() {
                let index = 1;
                if (!this.ShowLowestAPR && this.EstPaymentOffers) {
                    this.EstPaymentOffers.forEach((item) => {
                        item.Position = index;
                        index++;
                    });
                    this.TrackOfferResult = this.EstPaymentOffers;
                }
                this.rateTableViewedInfo(this);
            },
        },
        mounted() {
            setTimeout(() => {
                a11yModal.initModal();
            }, 1000);
            this.GraphQlUri = this.graphQlUri !== '' ? this.graphQlUri : getFinancialApiUrl();
            this.createGraphQlClient(this.GraphQlUri, setHeader);
            this.CreditScoreList = CreditScoreList.ratetablepersonalloanv2;
            this.PersonalLoanPurposeList = LoanTypeList.PersonalLoanPurposeList;
            this.GetSelectedCreditScore();
            this.getLocationByZip(this.ZipCode);
        },
        methods: {
            closeA11yModal() {
                a11yModal.closeModal();
            },
            closeModal() {
                this.showModal = false;
            },
            showHideLocation() {
                this.ShowLocation = !this.ShowLocation;
            },
            checkLoanAmount(loanAmount) {
                this.LoanAmount = Accounting.formatMoney(
                    loanAmount < 1000
                        ? 1000
                        : loanAmount > 50000
                            ? 50000
                            : loanAmount,
                    { symbol: '', precision: 0 },
                );
            },
            updateLoanAmount(loanAmount) {
                this.LoanAmount = this.unformatFigure(loanAmount);
            },
            GetSelectedCreditScore() {
                this.SelectedCreditScore = this.CreditScoreList.find(obj => obj.value === parseInt(this.CreditScore, 10)).text;
            },
            getLocationByZip(zip) {
                this.ZipCode = zip;
                if (this.zipCodeValidator()) {
                    this.ShowZipCodeError = false;
                    GetLocation.methods.GetZipCode(this.ZipCode, this.checkLocationResponse);
                } else {
                    this.ShowZipCodeError = true;
                }
            },
            zipCodeValidator() {
                const zipCodeRegEx = /^\d{5}$/;
                return zipCodeRegEx.test(this.ZipCode) && this.ZipCode !== '';
            },
            checkLocationResponse(location) {
                if (!location.err) {
                    this.ZipCode = location.zipCode;
                } else {
                    this.ShowZipCodeError = true;
                }
            },
            currencyFilter(figure) {
                return Accounting.formatNumber(figure);
            },
            fetchLenders() {
                this.ShowLocation = true;
                this.ShowZipCode = null;
                this.$nextTick(() => {
                    this.ShowZipCode = false;
                });
                this.fetchPlLenders();
            },
            getGeoDetails(location) {
                this.GeoLocation.city = location.city;
                this.GeoLocation.state = location.state;
                this.Zipcode = location.zipCode;
                this.$nextTick(() => {
                    this.ShowLowestAPR = true;
                });
                this.fetchPlLenders();
            },
            async fetchPlLenders() {
                this.updateLoanAmount(this.LoanAmount);
                this.DestinationTarget = this.destinationTarget;
                this.DestinationTarget += `&PersonalLoanPurposeCode=${this.PersonalLoanPurpose.replace(/ /g, '')}`;
                this.isPLfatched = false;
                this.Offers = [];
                this.MinAprOffers = [];
                this.EstPaymentOffers = [];
                const loanIntAmount = this.LoanAmount;
                const loanRange = loanIntAmount / 10000 - (loanIntAmount % 10000 === 0 ? 1 : 0);
                const variables = {
                    loanAmtBand: parseInt(loanRange, 10),
                    creditBand: this.CreditScore,
                    loanPurpose: this.PersonalLoanPurpose,
                    state: this.GeoLocation.state.trim(),
                };
                try {
                    const data = await this.graphQlQuery(getPLOffers, variables);
                    if (data && data.result) {
                        this.Offers = data.result;
                        let index = 1;
                        this.Offers.forEach((offer) => {
                            offer.details = {};
                            const estPayment = PaymentHelper.getPayment(parseInt(this.unformatFigure(this.LoanAmount), 10), offer.loanLength, PaymentHelper.convertInterestRatePerMonths(offer.minApr));
                            offer.estPayment = estPayment !== Infinity && estPayment !== undefined && !isNaN(estPayment) ? estPayment : 0;
                            this.LenderIds.push({ LenderId: offer.lenderId });
                        });

                        this.MinAprOffers = this.getSortedOffers(this.Offers, 'minApr');
                        this.EstPaymentOffers = this.getSortedOffers(this.Offers, 'estPayment');

                        this.TotalOffers = this.Offers.length;
                        this.isPLfatched = null;
                        if (this.ShowLowestAPR && this.MinAprOffers && this.MinAprOffers.length > 0) {
                            this.MinAprOffers.forEach((item) => {
                                item.Position = index;
                                index++;
                            });
                            this.TrackOfferResult = this.MinAprOffers;
                        }
                        this.rateTableViewedInfo(this);
                        this.$nextTick(() => {
                            this.isPLfatched = true;
                            this.ShowLowestAPR = true;
                        });
                    }
                } catch (e) {
                    console.warn(`Error getting PL offers: ${e}`);
                }
            },
            updateLenderDetails(lenderData) {
                if (lenderData.lenderId != null) {
                    const offerDetails = find(this.Offers, lender => lenderData.lenderId === lender.lenderId);
                    if (offerDetails !== undefined) {
                        offerDetails.details = lenderData;
                    }
                }
            },
            getSortedOffers(offerList, key) {
                const offers = offerList.slice();
                if (offers !== undefined) {
                    offers.sort((a, b) => {
                        if (a[key] > b[key]) {
                            return 1;
                        }
                        if (a[key] < b[key]) {
                            return -1;
                        }
                        return 0;
                    });
                }

                return offers;
            },
            tabClick(event, offerList, key, val) {
                const { keyCode } = event;
                const keys = {
                    enter: 13,
                    space: 32,
                    leftKey: 37,
                    rightKey: 39,
                };

                const tab1 = document.querySelector('#li-low-apr');
                const tab2 = document.querySelector('#li-low-loan-payment');

                switch (keyCode) {
                    case keys.enter:
                    case keys.space:
                        this.ShowLowestAPR = val;
                        event.preventDefault();
                        break;
                    case keys.leftKey:
                        this.ShowLowestAPR = true;
                        tab1.focus();
                        event.preventDefault();
                        break;
                    case keys.rightKey:
                        this.ShowLowestAPR = false;
                        tab2.focus();
                        event.preventDefault();
                        break;
                    default:
                        break;
                }
            },
            checkAPR(val) {
                return val ? 'APR Range' : 'Estimated Payment';
            },
            checkESP(val) {
                return val ? 'Estimated Payment' : 'APR Range';
            },
        },
    };
</script>
<style src="../../assets/styles/common.scss" lang="scss"></style>
<style src="../../assets/styles/tabs.scss" lang="scss"></style>
<style src="./main.scss" lang="scss"></style>
<style src="../../assets/styles/a11yModal.scss" lang="scss"></style>
